import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import InputField from "./InputField";
import Button from "./Button";
import Card from "./Card";
import { validateForm } from "./Validate";
import Swal from "sweetalert2";

const Super_Admin_Login = () => {
  const [formData, setFormData] = useState({
    phone: "",
    otp: "",
  });
  const [generatedOtp, setGeneratedOtp] = useState(null);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [SuperAdminName, setSuperAdminName] = useState();
  useEffect(() => {
    const storedProfessionId = sessionStorage.getItem("profession_id");
    if (storedProfessionId) {
      // Additional functionality for profession_id if needed
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleGetOtp = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm(formData, ["phone"]);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await axios.post(
        "/super_admin/super_admin_login_check",
        { mobile_number: formData.phone }
      );

      if (response.data.exists) {
        const otp = Math.floor(100000 + Math.random() * 900000);
        setGeneratedOtp(otp);
        const superAdminName = response.data.super_admin_name;
        setSuperAdminName(superAdminName);
        window.otp = otp; // Store in window for development purposes
        sessionStorage.setItem("mobile", btoa(formData.phone));
        const url = `https://www.fast2sms.com/dev/bulkV2?authorization=yG79LEBAXgYvWxOawmNf5Zse8boQdkFztpJ4KlTiDM0CVjrUS6hMsovdR51XNtenzpZwj9Q7iDKk3ylW&route=dlt&sender_id=CINGO&message=159863&variables_values=${otp}&flash=0&numbers=${formData.phone}`;
        fetch(url).then((data) => {
          Swal.fire({
            icon: "success",
            title: "OTP Sent!",
            text: `An OTP has been sent to your mobile number.`,
            confirmButtonText: "OK",
          }).then(() => {
            setShowOtpInput(true);
          });
        });
      } else {
        Swal.fire({
          icon: "info",
          title: "Mobile Number Not Found",
          text: "Please create an account first.",
          confirmButtonText: "Sign Up",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    if (formData.otp === String(generatedOtp)) {
      Swal.fire({
        icon: "success",
        title: "OTP Verified",
        text: "You will be redirected to the dashboard.",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/super_admin_dashboard"); // Pass the name via state
        sessionStorage.setItem("SuperAdminName", SuperAdminName);
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
        text: "The OTP you entered is incorrect. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="relative min-h-screen">
      <img
        src="/bg_image.jpg"
        alt="Background"
        className="absolute inset-0 object-cover w-full h-full z-0 filter grayscale hover:grayscale-0"
      />
      <div className="absolute inset-0 bg-gray-700 opacity-50 z-10" />
      <div className="relative min-h-screen flex items-center justify-center z-20">
        <Card className="max-w-md p-4 shadow-lg bg-white rounded-lg">
          <img src="/jci_logo.png" alt="Logo" className="w-20 mx-auto mb-4" />
          <h2 className="text-lg font-semibold text-center mb-4">
            Super Admin Login to your account
          </h2>
          <form onSubmit={handleGetOtp} className="space-y-4">
            <div>
              <InputField
                label="Mobile Number"
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="9087562345"
                required
                error={errors.phone}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <Button
                label="GET OTP"
                type="submit"
                className="w-full px-4 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
              />
            </div>

            {showOtpInput && (
              <div>
                <InputField
                  label="Enter OTP"
                  type="text"
                  name="otp"
                  value={formData.otp}
                  onChange={handleChange}
                  placeholder="Enter the OTP"
                  required
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md"
                />
                <Button
                  label="Login"
                  onClick={handleVerifyOtp}
                  className="w-full mt-2 px-4 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600"
                />
              </div>
            )}
          </form>
        </Card>
      </div>
    </div>
  );
};

export default Super_Admin_Login;
